import Button, { ButtonProps } from '@carvana/ds-button';
import { AnalyticsAttributes } from '@carvana/merch-components/contracts';
import React from 'react';
import { useSecondaryButtonHandler } from '~/hooks/vdp/cta';
import useSecondaryCtaButtonCopy from '~/hooks/vdp/selectors/useSecondaryCtaButtonCopy';
import { useGetCtaWrapperContent } from '../CtaWrapper';

const dummyFunction = () => {};

type OwnProps<T> = {
  ButtonComponent?: React.ComponentType<any>;
  className?: string;
  'data-analytics-id': string | null;
  'data-analytics-attributes'?: AnalyticsAttributes;
  'data-testid'?: string;
  onClick?: () => void;
} & T;

export default function SecondaryCtaButton<T = ButtonProps>({
  ButtonComponent = Button,
  className = '',
  'data-analytics-id': analyticsId,
  'data-analytics-attributes': analyticsAttributes,
  'data-testid': testId,
  onClick = dummyFunction,
  ...rest
}: OwnProps<T>) {
  const handleOnClick = useSecondaryButtonHandler(onClick) ?? dummyFunction;
  const { showCtaFooter } = useGetCtaWrapperContent();
  const secondaryCtaText = useSecondaryCtaButtonCopy();

  return secondaryCtaText ? (
    <ButtonComponent
      className={className}
      onClick={handleOnClick}
      data-adobe-id={null}
      data-analytics-id={analyticsId}
      data-analytics-attributes={JSON.stringify({
        ...analyticsAttributes,
        description: 'secondary cta',
        text: secondaryCtaText
      })}
      data-testid={testId}
      variant={showCtaFooter ? 'primaryInverted' : 'secondary'}
      {...rest}
    >
      {secondaryCtaText}
    </ButtonComponent>
  ) : null;
}
